'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useSetAtom } from 'jotai'
import { displayProductPriceIncludedTaxDrawerAtom } from '../../services/product.store'

import { Link } from '@/ui/links/link/Link.client'

export function ProductPriceIncludedTaxLink(): React.ReactNode {
  const { t } = useTranslation(['generic'])

  const setIsOpen = useSetAtom(displayProductPriceIncludedTaxDrawerAtom)

  return (
    // TODO: Use button v2 when available
    <Link
      variant="free"
      href="#"
      underlined="invert"
      bold
      onPress={(e) => {
        e.preventDefault()
        setIsOpen(true)
      }}
    >
      {t('generic:includeTax')}
    </Link>
  )
}
